// src/pages/ChinaLandingFull.js
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import "./ChinaLanding.css";
// import wechatQR from "../assets/wechat-qr.png"; // Add your QR image in assets

function ChinaLandingFull() {
  const [lang, setLang] = useState("en"); // en or zh

  const content = {
    en: {
      title: "SamSoftix | Business Websites, LMS & Management Systems for China",
      description:
        "SamSoftix provides professional website development, management systems, SEO optimization, LMS platforms, eCommerce, and AI solutions to help businesses in China grow online. Featured projects: myeduflow.eu, anasimfragrance.com, gamehub.samsoftix.com, alabarajalsamia.com.",
      hero: {
        h1: "Build High-Quality Websites, LMS & Business Systems for China",
        p: "SamSoftix helps companies establish strong online presence with websites, SEO, LMS platforms, eCommerce, and management systems to increase clients and grow business.",
        cta: "Get Free Consultation",
      },
      services: [
        { title: "Business Website Development", desc: "High-performance, SEO-friendly websites for attracting global clients." },
        { title: "SEO & Google/Baidu Ranking", desc: "Professional SEO services to improve online visibility and keyword ranking." },
        { title: "Business Management Systems", desc: "Custom CRM, ERP, inventory, and automation systems for business efficiency." },
        { title: "LMS Online Education Systems", desc: "Complete LMS platforms including course management, student tracking, and online learning." },
        { title: "E-commerce Platforms", desc: "Cross-border e-commerce websites with payments, logistics, and product management." },
        { title: "AI & Automation Solutions", desc: "AI-driven automation to reduce cost and enhance operational efficiency." },
      ],
      testimonials: [
        { text: "SamSoftix built our cross-border e-commerce platform and improved online sales dramatically.", author: "Shanghai, China" },
        { text: "The LMS system developed by SamSoftix helped us manage students efficiently.", author: "Beijing, China" },
      ],
      projects: [
        {
          name: "MyEduFlow.eu",
          desc: "A full-featured LMS system designed for online education in China and Europe, including courses, student management, and analytics.",
          url: "https://myeduflow.eu",
        },
        {
          name: "AnasimFragrance.com",
          desc: "Elegant e-commerce platform for premium fragrance products with international shipping.",
          url: "https://anasimfragrance.com",
        },
        {
          name: "GameHub.samsoftix.com",
          desc: "Interactive gaming platform with real-time leaderboard, user engagement, and social sharing.",
          url: "https://gamehub.samsoftix.com",
        },
        {
          name: "AlabaraJalSamia.com",
          desc: "Professional business website with integrated CRM and e-commerce capabilities for the Middle East market.",
          url: "https://alabarajalsamia.com",
        },
      ],
      why: {
        h2: "Why Choose SamSoftix?",
        points: [
          "International project experience (China, Dubai, Europe)",
          "High-quality development + fast delivery",
          "SEO & Baidu ranking optimization experts",
          "All-in-one solutions: Website + Systems + Marketing",
          "Affordable pricing with premium quality",
        ],
      },
      contact: {
        email: "info@samsoftix.com",
        whatsapp: "+923320472184",
        facebook: "https://facebook.com/samsoftix",
        linkedin: "https://linkedin.com/company/samsoftix",
      },
      cta: { h2: "Boost Your Business Now", p: "Contact us for a free consultation and business solutions", btn: "Contact Us" },
    },
    zh: {
      title: "SamSoftix | 中国企业网站、LMS及管理系统解决方案",
      description:
        "SamSoftix 为中国企业提供网站开发、管理系统、SEO优化、在线教育系统(LMS)、电商平台和AI解决方案，帮助企业线上业务增长。重点项目：myeduflow.eu, anasimfragrance.com, gamehub.samsoftix.com, alabarajalsamia.com。",
      hero: {
        h1: "为中国企业打造高质量网站、LMS与管理系统",
        p: "SamSoftix 帮助企业建立强大的线上业务，包括网站、SEO、LMS平台、电商及管理系统，提升客户获取与业务增长。",
        cta: "免费咨询",
      },
      services: [
        { title: "企业网站开发", desc: "构建高性能、SEO优化的网站，吸引全球客户。" },
        { title: "SEO优化 & Google/Baidu排名", desc: "专业SEO服务，提高关键词排名和线上曝光度。" },
        { title: "企业管理系统", desc: "定制CRM、ERP、库存及自动化系统，提高企业效率。" },
        { title: "LMS在线教育系统", desc: "完整的在线学习平台，包括课程管理、学生管理与学习分析。" },
        { title: "电商平台开发", desc: "跨境电商网站，支持支付、物流及商品管理。" },
        { title: "AI与自动化解决方案", desc: "AI驱动自动化解决方案，降低成本并提升效率。" },
      ],
      testimonials: [
        { text: "SamSoftix 为我们开发的跨境电商平台大幅提升了线上销售。", author: "中国上海" },
        { text: "SamSoftix 开发的LMS系统让我们高效管理学生。", author: "中国北京" },
      ],
      projects: [
        {
          name: "MyEduFlow.eu",
          desc: "一个为中国及欧洲设计的全功能LMS系统，包括课程、学生管理及分析功能。",
          url: "https://myeduflow.eu",
        },
        {
          name: "AnasimFragrance.com",
          desc: "高端香水电商平台，支持国际物流配送。",
          url: "https://anasimfragrance.com",
        },
        {
          name: "GameHub.samsoftix.com",
          desc: "互动游戏平台，包含实时排行榜、用户互动及社交分享功能。",
          url: "https://gamehub.samsoftix.com",
        },
        {
          name: "AlabaraJalSamia.com",
          desc: "中东市场专业企业网站，集成CRM和电商功能。",
          url: "https://alabarajalsamia.com",
        },
      ],
      why: {
        h2: "为什么选择 SamSoftix?",
        points: [
          "国际项目经验（中国、迪拜、欧洲）",
          "高质量开发 + 快速交付",
          "SEO优化 + Baidu排名专家",
          "一站式解决方案（网站 + 系统 + 营销）",
          "成本低，质量高",
        ],
      },
      contact: {
        email: "info@samsoftix.com",
        whatsapp: "+923320472184",
        facebook: "https://facebook.com/samsoftix",
        linkedin: "https://linkedin.com/company/samsoftix",
      },
      cta: { h2: "立即提升您的业务", p: "联系我们，获取免费咨询与解决方案", btn: "联系我们" },
    },
  };

  const langContent = content[lang];

  return (
    <div className="china-page">
      {/* SEO / Baidu + Google */}
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="index, follow" />
        <title>{langContent.title}</title>
        <meta name="description" content={langContent.description} />
        <meta name="keywords" content="SamSoftix, China, Web development, LMS, eCommerce, SEO, AI, Management Systems, myeduflow.eu, anasimfragrance.com, gamehub.samsoftix.com, alabarajalsamia.com" />
        <link rel="canonical" href="https://www.samsoftix.com/china" />

        {/* Open Graph */}
        <meta property="og:title" content={langContent.title} />
        <meta property="og:description" content={langContent.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.samsoftix.com/china" />
        <meta property="og:site_name" content="SamSoftix" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "SamSoftix",
            description: langContent.description,
            url: "https://www.samsoftix.com/china",
            telephone: langContent.contact.whatsapp,
            email: langContent.contact.email,
            address: {
              "@type": "PostalAddress",
              streetAddress: "Wan, Sambrial",
              addressLocality: "Sialkot",
              addressRegion: "Punjab",
              postalCode: "51010",
              addressCountry: "PK",
            },
            sameAs: [langContent.contact.facebook, langContent.contact.linkedin],
            areaServed: ["China"],
            serviceOffered: langContent.services.map(s => ({ "@type": "Service", name: s.title, description: s.desc })),
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: "Projects",
              itemListElement: langContent.projects.map(p => ({
                "@type": "SoftwareApplication",
                name: p.name,
                url: p.url,
                applicationCategory: "Business/Website/LMS",
                description: p.desc,
              })),
            },
          })}
        </script>
      </Helmet>

      {/* LANGUAGE SWITCHER */}
      <div className="lang-switcher">
        <button onClick={() => setLang("en")} disabled={lang === "en"}>English</button>
        <button onClick={() => setLang("zh")} disabled={lang === "zh"}>中文</button>
      </div>

      {/* HERO */}
      <motion.section className="china-hero" initial={{ opacity: 0, y: -40 }} animate={{ opacity: 1, y: 0 }}>
        <h1>{langContent.hero.h1}</h1>
        <p>{langContent.hero.p}</p>
        <a href="/contact" className="cta-btn">{langContent.hero.cta}</a>
      </motion.section>

      {/* SERVICES */}
      <motion.section className="china-services">
        <h2>{lang === "en" ? "Our Core Services" : "我们的核心服务"}</h2>
        <div className="grid">
          {langContent.services.map((s, i) => (
            <div key={i} className="card">
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </motion.section>

      {/* PROJECTS */}
      <motion.section className="china-projects">
        <h2>{lang === "en" ? "Highlighted Projects" : "重点项目"}</h2>
        <div className="grid">
          {langContent.projects.map((p, i) => (
            <div key={i} className="card">
              <h3>{p.name}</h3>
              <p>{p.desc}</p>
              <a href={p.url} target="_blank" rel="noreferrer" className="cta-btn" style={{ marginTop: '1rem', fontSize: '0.95rem', padding: '0.8rem 1.5rem' }}>
                {lang === "en" ? "Visit Project" : "查看项目"}
              </a>
            </div>
          ))}
        </div>
      </motion.section>

      {/* WHY CHOOSE */}
      <motion.section className="china-why">
        <h2>{langContent.why.h2}</h2>
        <ul>
          {langContent.why.points.map((p, i) => (
            <li key={i}>✔ {p}</li>
          ))}
        </ul>
      </motion.section>

      {/* TESTIMONIALS */}
      <motion.section className="china-testimonials">
        <h2>{lang === "en" ? "Client Testimonials" : "客户评价"}</h2>
        <div className="grid">
          {langContent.testimonials.map((t, i) => (
            <blockquote key={i} className="testimonial">
              <p>"{t.text}"</p>
              <cite>{t.author}</cite>
            </blockquote>
          ))}
        </div>
      </motion.section>

      {/* WECHAT QR + CONTACT FORM */}
      <motion.section className="china-contact">
        <h2>{lang === "en" ? "Contact & WeChat" : "联系我们 & 微信"}</h2>
        <div className="contact-grid">
          <div className="wechat">
            <p>{lang === "en" ? "Scan to contact us on WeChat" : "扫描二维码添加微信咨询"}</p>
            {/* <img src={wechatQR} alt="WeChat QR" /> */}
          </div>
          <div className="contact-info">
            <p>Email: <a href={`mailto:${langContent.contact.email}`}>{langContent.contact.email}</a></p>
            <p>WhatsApp: <a href={`https://wa.me/${langContent.contact.whatsapp.replace(/\D/g,'')}`}>{langContent.contact.whatsapp}</a></p>
            <p>Facebook: <a href={langContent.contact.facebook} target="_blank" rel="noreferrer">Facebook</a></p>
            <p>LinkedIn: <a href={langContent.contact.linkedin} target="_blank" rel="noreferrer">LinkedIn</a></p>
          </div>
        </div>
      </motion.section>

      {/* CTA */}
      <motion.section className="china-cta">
        <h2>{langContent.cta.h2}</h2>
        <p>{langContent.cta.p}</p>
        <a href="/contact" className="cta-btn">{langContent.cta.btn}</a>
      </motion.section>
    </div>
  );
}

export default ChinaLandingFull;